






import Vue from 'vue';
import BlockType3Grid from './BlockType3Grid.vue';
import BlockType3List from './BlockType3List.vue';
import BlockTypeSettings from '@headlines/types/block/1-10/blockType3';
import { HeadlineWithRelatedArticles } from '@headlines/types/headline';

interface Computed {
  type: string;
}

interface Props {
  data: {
    items: HeadlineWithRelatedArticles[];
  };
  settings: BlockTypeSettings;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    BlockType3Grid,
    BlockType3List,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    type() {
      let type = this.settings.type;
      type = type && (type === 'grid' || type === 'list') ? type : 'list';

      return type;
    },
  },
});
